import React, { useState } from 'react';
import { Chip } from 'ui';
import ColorConstants from 'constants/ColorConstants'
import { CODE_COLORS, CODE_TAG_BACKGROUND_COLORS } from 'constants/CodeColorConstants';

const baseStyle = {
  fontWeight: "normal",
  transition: 'all 0.3s ease-in-out'
};

const defaultStyle = {
  ...baseStyle,
  color: ColorConstants.DARK_GREY, 
  backgroundColor: 'white'
};

const darkStyle = {
  ...baseStyle,
  color: ColorConstants.ULTRA_LIGHT_GREY, 
  backgroundColor: ColorConstants.DARK_GREY
};

const CodePill = (props) => {
  const [isHovering, setIsHovering] = useState(false);
  const { codeColor, selected, onClick, name, dark } = props;

  const selectedStyle = {
    ...baseStyle,
    color: ColorConstants.DARK_GREY,
    backgroundColor: CODE_TAG_BACKGROUND_COLORS[codeColor]
  };

  const getStyleForState = () => {
    // Dark mode always uses dark style, regardless of hover/selection
    if (dark) {
      return darkStyle;
    }

    // For non-dark mode, use selected style when hovering or selected
    if (isHovering || selected) {
      return selectedStyle;
    }

    // Default style for non-dark, non-hovering, non-selected
    return defaultStyle;
  };

  const dynamicStyle = getStyleForState();

  const style = {
    ...dynamicStyle,
    border: `1px solid ${CODE_COLORS[codeColor]}`,
  };

  const containerStyle = {
    marginRight: 0, 
    maxWidth: "100%",
    transition: 'all 0.3s ease-in-out'
  };

  const textStyle = {
    paddingBottom: '2px',
    display: 'inline-block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '80%',
    verticalAlign: 'middle',
    transition: 'all 0.3s ease-in-out'
  };

  return (
    <span
      style={containerStyle}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <Chip onClick={onClick} style={style}>
        <div style={textStyle} className='code-pill'>
          {name}
        </div>
      </Chip>
    </span>
  );
};

export default CodePill;